module.exports = "<h2>\n  Conferma\n</h2>\n<md-dialog-content>\n  <div >\n      {{this.confirmDescriptor.text}}\n  </div>\n  <div class=\"\">\n    <button class=\"btn btn-primary\" (click)=\"okButtonClick()\">OK\n    </button>\n    <button class=\"btn btn-danger\" (click)=\"annullaButtonClick()\">\n      Annulla\n    </button>\n  </div>\n</md-dialog-content>\n"


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/generic_dialogs/confirm-dialog/confirm-dialog.component.html
// module id = ../../../../../src/app/components/generic_dialogs/confirm-dialog/confirm-dialog.component.html
// module chunks = main